import { takeLatest, all, put, call } from 'redux-saga/effects';
import { enums } from 'console-kit';

import ConsoleAppActions from '../../App/redux/app-actions';
import AccountActions from './account-actions';
import AccountModel from './account-model';
import AccountApi from './account-api';

function* fetchCurrentAccountHandler() {
  try {
    /**
     * Previouusly this made a call to AccountApi.fetchCurrentAccount, but that call is presently blocked for the User role which causes an issue for gateKeeper.
     * While we figure out proper permissioning around this endpoint we will continue to use the global account, but are wrapping it with a Model to minimize the direct dependency on the global.
     */
    const account = AccountModel.deserialize(App.globalContext.account);
    yield put(AccountActions.fetchCurrentAccountSuccess(account));
  } catch (error) {
    yield put(AccountActions.fetchCurrentAccountFailure(error));
  }
}

function* fetchRelativeAccountsHandler() {
  const response = yield call(AccountApi.fetchRelativeAccounts);
  if (response.error) yield put(AccountActions.fetchRelativeAccountsFailure(response.error));
  else yield put(AccountActions.fetchRelativeAccountsSuccess(response));
}

function* saveCurrentAccountHandler({ payload: { accountSettings } }) {
  const response = yield call(AccountApi.updateAccount, accountSettings);

  if (response.error) {
    yield put(AccountActions.saveCurrentAccountFailure(response.error));
  } else {
    yield put(
      ConsoleAppActions.setAlertMessage({
        messageType: enums.messageTypes.SUCCESS,
        header:      'Success',
        byline:      response.successMessage,
      })
    );
    yield put(AccountActions.saveCurrentAccountSuccess(response.account));
  }
}

export default function* accountSagas() {
  yield all([takeLatest(AccountActions.saveCurrentAccount.getType(), saveCurrentAccountHandler)]);
  yield all([takeLatest(AccountActions.fetchCurrentAccount.getType(), fetchCurrentAccountHandler)]);
  yield all([takeLatest(AccountActions.fetchRelativeAccounts.getType(), fetchRelativeAccountsHandler)]);
}
